/**
 * Amazon Connect Chat Widget Configuration - SCTASK0746850
 * Environment-specific configuration for chat widget integration
 */

export interface AmazonConnectConfig {
  widgetId: string;
  snippetId: string;
}

// Environment-specific widget configurations
export const AMAZON_CONNECT_CONFIGS: Record<string, AmazonConnectConfig> = {
  develop: {
    widgetId: 'e57d67c7-092e-4403-85f0-6483a1f510c0',
    snippetId:
      'QVFJREFIaGRXUHpDQ0syTWozT3FtUTlKL1lZeW8zbzdUZEQ4Y1A3d0wzMWFuQ0RFM0FHZEpGdUI4L0VEYUo1cG80azc0VzRDQUFBQWJqQnNCZ2txaGtpRzl3MEJCd2FnWHpCZEFnRUFNRmdHQ1NxR1NJYjNEUUVIQVRBZUJnbGdoa2dCWlFNRUFTNHdFUVFNSG1LVURwZTY4R1Z4cXFRdEFnRVFnQ3NiWEYrRGNWNnVPOWIrbkJPbzB0NnhCNGdNRERYUUxMMlk4dDBZaDZpektwa3dhazNGeGs0eEpkc0U6Oms0V0N3c3lrK1VrWWVGOExQcFNNelBxWnJUR1FaZU9HUmZaRHVsVGUyeGdrTXIvNHcxOUVjUGkvRVBxS05OZnFEOUNIaURpdERsMmp6WGlCSVpQQ2k3ODBTaWg3bS84NU5UTjZIRGVjQUVtc3hhOGtVU0wzcjJVUzFMTTI4THl0N1hvTGhwL1dQQ3dlVnIzTEduOWNSektRMDFmWVdJZz0=',
  },
  development: {
    widgetId: '30b644fd-2439-4e96-965e-bd896fd87986',
    snippetId:
      'QVFJREFIaGRXUHpDQ0syTWozT3FtUTlKL1lZeW8zbzdUZEQ4Y1A3d0wzMWFuQ0RFM0FIQ0dzRjRqMmhib2FqV2JYZHRab04wQUFBQWJqQnNCZ2txaGtpRzl3MEJCd2FnWHpCZEFnRUFNRmdHQ1NxR1NJYjNEUUVIQVRBZUJnbGdoa2dCWlFNRUFTNHdFUVFNbzEyS2lWL2FxU0ZkZkFsQ0FnRVFnQ3QzQjhsSmlSdHdBUXAwR0JGSjV2cFQ4bzdQQlZzYmRSazdlNlF1VEZ5dmpMY2ZXVzhQVWFTTWdrTlM6OlFrLzRnaVhwSXcrbUt1V2JmWnBwdW5XayszVHpzcUE2ZmV6Ym1iUjNaOXh3UGxVUk1Oazg3QUllRHJOelIrNnFid0xIQWZKV2I5b0x2NlpVL1FRVThQenJJTzFrM0pkWFZUTWpJZEJSbjFaWXhRTkYvQUpDV2Z3UlcrZjBIQis4WG1tR3VOY2NkV2xjOXN2ZjRGdDF1VDdkZXNuVXBBUT0=',
  },
  production: {
    widgetId: '4ef3b14b-672e-448a-b11c-5c4788c0e05c',
    snippetId:
      'QVFJREFIaGRXUHpDQ0syTWozT3FtUTlKL1lZeW8zbzdUZEQ4Y1A3d0wzMWFuQ0RFM0FHOWIwREpkQ0hIVmo5eUUvNHBNM3NHQUFBQWJqQnNCZ2txaGtpRzl3MEJCd2FnWHpCZEFnRUFNRmdHQ1NxR1NJYjNEUUVIQVRBZUJnbGdoa2dCWlFNRUFTNHdFUVFNd1BrWkxLeXpwTER1WWhVOEFnRVFnQ3NPcS9XbENxZE5rV3BHVjRwcHNuQ3NTMjBRQTFDUUpEL3M2OGFDZjZxK0h2MWRENnhCWm9INVcxTTk6OnFuOGdFNVVJWDl0MmNxWWVCWHRWNE4yQTVXNWQvSldoNm9tQWxGOU9zRWdSWUZSZnJScHdJcFE3a29ndnlWNUJqWDJzVnhJRGh2Qis3RVhPTXp4UHE2VXBBOGgrSlA0RTdmekpGSUViN0tMVm0waWJwd1poSnRyVDdrYTdZem5YU0VyMUtVQ2VhbGNFbVo0UlMzZWh2TWFLKzJncXJxbz0=',
  },
};

// Widget styling configuration (same across all environments)
const WIDGET_STYLES = {
  iconType: 'CHAT',
  openChat: { color: '#ffffff', backgroundColor: '#d72527' },
  closeChat: { color: '#ffffff', backgroundColor: '#d72527' },
  headerConfig: { headerMessage: 'How can we help?', headerColorHex: '#d72527' },
  logoConfig: { sourceUrl: '' },
};

// Supported message content types
const SUPPORTED_CONTENT_TYPES = [
  'text/plain',
  'text/markdown',
  'application/vnd.amazonaws.connect.message.interactive',
  'application/vnd.amazonaws.connect.message.interactive.response',
];

// View configuration (same across all environments)
const VIEW_CONFIG = {
  arn:
    'arn:aws:connect:us-east-1:937506435045:instance/259cdbee-7ccb-402d-b09f-33c070c49c3f/view/c26f88c4-7b0a-44d8-90a7-3d37274f2385:$LATEST',
  id: 'c26f88c4-7b0a-44d8-90a7-3d37274f2385',
  content: {
    actions: ['ActionSelected'],
    inputSchema: {
      type: 'object',
      properties: {},
      required: [],
      $defs: {
        ViewCondition: {
          $id: '/view/condition',
          type: 'object',
          patternProperties: {
            '^(MoreThan|LessThan|NotEquals|Equals|Includes)$': {
              type: 'object',
              properties: {
                ElementByKey: { type: 'string' },
                ElementByValue: {
                  anyOf: [
                    { type: 'number' },
                    { type: 'string' },
                    { type: 'boolean' },
                    { type: 'array' },
                    { type: 'object' },
                  ],
                },
              },
              additionalProperties: false,
            },
            '^(AndConditions|OrConditions)$': {
              type: 'array',
              items: { $ref: '/view/condition' },
            },
          },
          additionalProperties: false,
        },
      },
    },
    template: {
      Head: {
        Configuration: { Layout: { Columns: [12] } },
        Integrations: [],
        Title: 'PreChat',
      },
      Body: [
        {
          _id: 'TemplateStringComponent_1769895232125',
          Type: 'TemplateStringComponent',
          Props: {
            TemplateString:
              '<Container>{<div>Thanks for contacting Texas.gov tech support. We are available 7AM - 8PM Central, 7 days a week. <br/>We help:  <br/>- Find Texas.gov info<br/>- Troubleshoot application or payment errors.<br/><br/>Note:<br/>- We don&apos;t have access to state agency info.<br/>- We don&apos;t support the DPS scheduler system<br/><a href=\\"https://www.votetexas.gov\\" target=\\"_blank\\" rel=\\"noopener noreferrer\\">Get Voter Info</a></div>}</Container>',
          },
          Content: [],
        },
        {
          _id: 'Form_1769895293457',
          Type: 'Form',
          Props: { HideBorder: false },
          Content: [
            {
              _id: 'FirstName_1769895293457',
              Type: 'FormInput',
              Props: { Label: 'Name', Name: 'name', InputType: 'text', Required: true },
              Content: [],
            },
            {
              _id: 'LastName_1769895293457',
              Type: 'FormInput',
              Props: { Label: 'Email', Name: 'email', InputType: 'email', Required: true },
              Content: [],
            },
            {
              _id: 'FormInput_1769895390756',
              Type: 'FormInput',
              Props: {
                Label: 'Phone',
                Name: 'phone',
                DefaultValue: '',
                InputType: 'tel',
                Required: true,
                HelperText: '',
                ValidationPattern: '',
                Disabled: false,
              },
              Content: [],
            },
            {
              _id: 'ConnectAction_1769895480588',
              Type: 'ConnectAction',
              Props: {
                ConnectActionType: 'StartChatContact',
                Label: 'Chat Now',
                StartTaskContactProps: {
                  ContactFlowId: '',
                  TaskFields: { Name: '', References: {} },
                  Attributes: [{ Key: '', Value: '' }],
                },
                StartEmailContactProps: {
                  DestinationEmailAddress: '',
                  ContactFlowId: '',
                  EmailFields: {
                    CustomerDisplayName: '',
                    CustomerEmailAddress: '',
                    Subject: '',
                    Body: '',
                  },
                  Attributes: [{ Key: '', Value: '' }],
                },
                StartChatContactProps: {
                  ContactFlowId:
                    'arn:aws:connect:us-east-1:937506435045:instance/259cdbee-7ccb-402d-b09f-33c070c49c3f/contact-flow/2526467d-be12-4ec2-9047-f66becc872b9',
                  ChatFields: {
                    CustomerDisplayName: { _linkedFormOutputName: 'name' },
                    InitialMessage: '',
                  },
                  Attributes: [
                    { Key: 'email', Value: { _linkedFormOutputName: 'email' } },
                    { Key: 'phone', Value: { _linkedFormOutputName: 'phone' } },
                    { Key: 'name', Value: { _linkedFormOutputName: 'name' } },
                  ],
                },
              },
              Content: ['Connect Action Button'],
            },
          ],
        },
      ],
    },
  },
  name: 'PreChat',
  status: 'PUBLISHED',
  type: 'CUSTOMER_MANAGED',
  viewContentSha256: 'c84caba6e9bc795d031bbe62073fa7cede11759795bbea45ba1b6b8ab2908798',
};

/**
 * Generates Amazon Connect chat widget script for the specified environment
 * @param environment - The deployment environment (develop, development, production)
 * @returns The complete script content for the widget initialization
 */
export function generateAmazonConnectScript(environment: string): string {
  const config = AMAZON_CONNECT_CONFIGS[environment];
  if (!config) {
    return '';
  }

  const viewConfigString = JSON.stringify(VIEW_CONFIG);

  return `
    (function(w, d, x, id){
        s=d.createElement('script');
        s.src='https://texas-gov.my.connect.aws/connectwidget/static/amazon-connect-chat-interface-client.js';
        s.async=1;
        s.id=id;
        d.getElementsByTagName('head')[0].appendChild(s);
        w[x] =  w[x] || function() { (w[x].ac = w[x].ac || []).push(arguments) };
    })(window, document, 'amazon_connect', '${config.widgetId}');
    amazon_connect('styles', ${JSON.stringify(WIDGET_STYLES)});
    amazon_connect('snippetId', '${config.snippetId}');
    amazon_connect('supportedMessagingContentTypes', ${JSON.stringify(SUPPORTED_CONTENT_TYPES)});
    amazon_connect('viewConfig', '${viewConfigString}');
  `;
}
